import {
  AfterViewInit,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import SwiperCore, {Pagination, Swiper, SwiperOptions} from 'swiper';
import {NgxGalleryAnimation, NgxGalleryImage, NgxGalleryOptions} from '@node_modules/ngx-gallery-9';


export enum TipoPaginadorSliderEnum {
  bullets =  'bullets',
  fraction = 'fraction',
  progressbar =  'progressbar',
  custom = 'custom'
}

export interface IMediaSlider {
  src: string;
  alt: string;
}
export interface IElementoSlider {
  media: IMediaSlider;
  titulo?: string;
  texto?: string;
  enlace?: string;
  boton?: string;
  orden?: number;
}


// borrar
export interface ImagenSlider {
  src: string;
  alt: string;
}


SwiperCore.use([Pagination, Swiper]);

@Component({
  selector: 'neo-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SliderComponent implements OnInit, AfterViewInit {
  // @Input() images: ImagenSlider[] = []; //borrar
  @Input() slides: IElementoSlider[] = [];
  //Configuración slider
  @Input() id = 'slider';
  @Input() effect: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' = 'slide';
  @Input() handlers = true;
  @Input() iconHandlerPrev = 'icon-20 icon-ibm-chevron_left';
  @Input() iconHandlerNext = 'icon-20 icon-ibm-chevron_right';
  @Input() loop = false;
  @Input() autoplay = true;
  @Input() interval = 5000;
  @Input() transition = 1500;
  @Input() slidesPerView: number | 'auto' = 1;
  @Input() spaceBetween = 0;
  @Input() paginacion: boolean | TipoPaginadorSliderEnum = false;
  @Input() tipoPaginacion: boolean | TipoPaginadorSliderEnum = false;
  @Input() tamanoTitulo: string;

  //Configuración galería
  @Input() mostrarGaleria = false;
  @Input() animacionGaleria: NgxGalleryAnimation = NgxGalleryAnimation.Slide;
  @Input() iconCerrarGaleria = 'icon-ibm--close icon-16';
  @Input() mostrarDescripcionImgGaleria = true;
  @Input() opcionFullScreenGaleria = true;
  // TODO: Cambiar icono por defecto
  @Input() iconFullScreenGaleria = 'icon-20 icon-ibm-maximize';
  @Output() movimientoSlide = new EventEmitter<any>();
  //Slider
  paginationConfig: boolean | object = false;
  handlersConfig: boolean | object = false;
  autoplayConfig: boolean | object = false;
  swiperConfig: SwiperOptions;


  //Galería
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];

  @ViewChild('swiper') swiper: Swiper;

  constructor() {

  }

  ngOnInit(): void {
    this.configurarSwiper();
    this.configurarGaleria();
  }

  ngAfterViewInit(): void {
    // this.swiper['swiper'].on('swiper', (event) => {
    //   console.log('Swipper ', event);
    // });

  }


  configurarSwiper() {
    this.mapPaginacion();
    this.mapHandlers();
    this.mapAutoPlay();
    this.swiperConfig = {
      effect: this.effect,
      fadeEffect: {
        crossFade: true
      },
      pagination: this.paginationConfig,
      navigation: this.handlersConfig,
      loop: this.loop,
      autoplay: this.autoplayConfig,
      speed: this.transition,
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetween,
      watchSlidesProgress: true,
    };
    this.swiperConfig.on = {
      init: function(swiper) {
        swiper.slides[swiper.activeIndex].classList.add('swiper-slide-loaded');
        if (swiper.originalParams.pagination['type'] === TipoPaginadorSliderEnum.fraction) {
          const actual = swiper.el.getElementsByClassName('swiper-progressbar');
          actual[0]?.animate({ width: '100%' }, swiper.originalParams.autoplay['delay']);
        }
      },
      slideChangeTransitionEnd: (swiper) => {
        swiper.slides[swiper.activeIndex].classList.add('swiper-slide-loaded');
        if (swiper.originalParams.pagination['type'] === TipoPaginadorSliderEnum.fraction) {
          const actual = swiper.el.getElementsByClassName('swiper-progressbar');
          actual[0]?.animate({ width: '100%' }, swiper.originalParams.autoplay['delay']);
        }
      },
      slideChangeTransitionStart: (swiper) => {
        swiper.slides[swiper.activeIndex].classList.remove('swiper-slide-loaded');
        setTimeout(() => this.movimientoSlide.emit(swiper), 200)
        if (swiper.originalParams.pagination['type'] === TipoPaginadorSliderEnum.fraction) {
          const actual = swiper.el.getElementsByClassName('swiper-progressbar');
          actual[0]?.getAnimations().map(animation => {
            animation.cancel();
          });
          actual[0]?.animate({ width: '0' });
        }
      },
      click: (event) => {
        setTimeout(() => this.movimientoSlide.emit(event), 200)
      },
    }
  }


  configurarGaleria() {
    this.galleryOptions = [
      {
        width: '0',
        height: '0',
        thumbnailsColumns: 0,
        arrowPrevIcon: this.iconHandlerPrev,
        arrowNextIcon: this.iconHandlerNext,
        imageAnimation: String(this.animacionGaleria),
        closeIcon: this.iconCerrarGaleria,
        imageDescription: this.mostrarDescripcionImgGaleria,
        previewFullscreen: this.opcionFullScreenGaleria,
        fullscreenIcon: this.iconFullScreenGaleria,
      },
    ];
    this.mapImgGaleria();
  }

  mapImgGaleria() {
    this.slides.map(image => {
      this.galleryImages.push(
        {
          description: image.media.alt,
          small: image.media.src,
          medium: image.media.src,
          big: image.media.src
        }
      );
    });
  }


  mapPaginacion() {
    if (this.paginacion) {
      this.paginationConfig = {
        el: '.swiper-pagination',
        type: this.tipoPaginacion,
        formatFractionCurrent: (number) => ('0' + number).slice(-2),
        formatFractionTotal: (number) => ('0' + number).slice(-2),
      }
    } else {
      this.paginationConfig = false;
    }
  }

  mapHandlers() {
    this.handlers ? this.handlersConfig =  {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    } : this.handlersConfig = false;
  }

  mapAutoPlay() {
    this.autoplay ? this.autoplayConfig = {
      delay: this.interval,
      disableOnInteraction: false,
    } : this.autoplayConfig = false;
  }

  get _TipoPaginadorSliderEnum() {
    return TipoPaginadorSliderEnum;
  }
}
